import * as React from "react";

function SvgIcFile(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M3.5 4.5C3.5 3.39543 4.39543 2.5 5.5 2.5H13.5C13.7652 2.5 14.0196 2.60536 14.2071 2.79289L20.2071 8.79289C20.3946 8.98043 20.5 9.23478 20.5 9.5V19.5C20.5 20.6046 19.6046 21.5 18.5 21.5H5.5C4.39543 21.5 3.5 20.6046 3.5 19.5V4.5ZM12.5 4.5H5.5V19.5H18.5V10.5H14.5C13.3954 10.5 12.5 9.60457 12.5 8.5V4.5ZM14.5 5.91421L17.0858 8.5H14.5V5.91421ZM7.5 6.5C7.22386 6.5 7 6.72386 7 7C7 7.27614 7.22386 7.5 7.5 7.5H10.5C10.7761 7.5 11 7.27614 11 7C11 6.72386 10.7761 6.5 10.5 6.5H7.5ZM7.5 8.5C7.22386 8.5 7 8.72386 7 9C7 9.27614 7.22386 9.5 7.5 9.5H10.5C10.7761 9.5 11 9.27614 11 9C11 8.72386 10.7761 8.5 10.5 8.5H7.5Z" fill="currentColor"/>
      <path d="M6.5 13C6.5 12.4477 6.94772 12 7.5 12H16.5C17.0523 12 17.5 12.4477 17.5 13C17.5 13.5523 17.0523 14 16.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13Z" fill="currentColor"/>
      <path d="M7.5 15.5C6.94772 15.5 6.5 15.9477 6.5 16.5C6.5 17.0523 6.94772 17.5 7.5 17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5C17.5 15.9477 17.0523 15.5 16.5 15.5H7.5Z" fill="currentColor"/>
    </svg>
  );
}

export default SvgIcFile;
